import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "@environments/environment";
import { RequestHelper } from "@helper/request.helper";
import { InquiryService } from "../services/inquiry.service";

const dataInquiry = {
    "appId" : "15006801",
    "refNo" : "MCH-1190-1640337564039TEST-ABC-000104323",
    "status" : 100,
    "sign" : ""
}

@Component({
    selector: 'app-akulaku-inquiry',
    templateUrl : './akulakuinquiry.component.html',
    styleUrls: ['./akulakuinquiry.component.css']
})
export class AkuLakuInquiryComponent implements OnInit{

    form: FormGroup;
    isSubmitted: boolean;
    hostname: any = environment.hostName;
    imgUri : string;
    successPage: number;

    appId: number;
    refNumber: string;
    amount: string;
    isValidateButton: boolean;
    redirectUri: string;
    sidePage: string;

    constructor(private router:Router, private inquiryService:InquiryService,
        private activatedRoute: ActivatedRoute,
        private apiService:RequestHelper){
        this.isSubmitted = false
        this.successPage = 0
        this.isValidateButton = false;
        this.sidePage = "N";
        /** init data from another page */
        console.log("ref numbers ->", this.activatedRoute.snapshot.paramMap.get('numberRef'));
        this.inquiryService.getOrderPayment(this.activatedRoute.snapshot.paramMap.get('numberRef')).subscribe(data => {
            console.log("data get order : ",data)
            this.appId = data.appId == null ? localStorage.getItem('appid_akulaku') : data.appId;
            this.refNumber = data.refNo == null ? localStorage.getItem('invoice_akulaku') : data.refNo;
            this.amount = data.totalPrice == null ? localStorage.getItem('amount_akulaku') : data.totalPrice;
            this.redirectUri = data.callbackPageUrl;
        }, error => console.log(error))
    }

    ngOnInit(): void {
        this.imgUri = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/financing/akulaku.png';
        this.form = new FormBuilder().group({
            invoiceNumber: [this.refNumber, [Validators.required]],
            amount: [this.amount, [Validators.required]],
            otp: [null, [Validators.required]]
        })
    }

    previousPage(){
        this.router.navigate(['/paylater-akulaku']);
    }

    paymentDone(){
        console.log("payment done click");
        window.location.href=this.redirectUri;
    }

    doInquiry(){
        console.log("otp => "+JSON.stringify(this.form.controls["otp"].value))
        if (this.form.controls["otp"].value != "00000"){
            console.log("payment error because otp not match");
            this.openDialog("Wrong OTP Value");
            localStorage.setItem('invoice_akulaku', this.refNumber);
            localStorage.setItem('amount_akulaku', this.amount);
            localStorage.setItem('appid_akulaku', JSON.stringify(this.appId));
        }else{
            var requestBody = {
                "appId" : this.appId,
                "refNo" : this.refNumber,
                "status" : 100,
                "sign" : "",
                "type" : "success"
            }
            console.log("data request : => ",requestBody)
            this.inquiryService.callbackPayment(requestBody).subscribe(data => {
                if (data.responseCode != null || data.responseCode == "0099"){
                    console.log("failed payment !");
                    this.successPage=0;
                    this.openDialog("payment failed");
                    this.sidePage = "N";
                }else if (data.code == 0){
                    console.log("success payment !");
                    this.successPage=1;
                    this.sidePage = "Y";
                }
            }, error => console.log("error payment from be"))
        }   
    }

    openDialog(result){
        this.apiService.openDialog(result, 'akulaku/payment');
    }
}